import { useTranslation } from 'react-i18next'

import {
  Checkbox,
  CHECKBOX_SIZE,
  CHECKBOX_TYPE,
} from '../../../../../../../../Checkbox'
import {
  FormikField,
  getFormikCheckboxFieldValueProps,
  getFormikFormFieldErrorProps,
} from '../../../../../../../../Formik'
import { LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS_INCLUDED } from '../../../RentalPortalListingProfileKeyFactsWidget.constants'

function HeatingIncludedField() {
  const { t } = useTranslation()

  return (
    <FormikField
      Component={Checkbox}
      getErrorProps={getFormikFormFieldErrorProps}
      getValueProps={getFormikCheckboxFieldValueProps}
      label={t('RentalPortal.ListingProfileHeatingIncludedFieldLabelKey')}
      name={LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS_INCLUDED}
      size={CHECKBOX_SIZE.small}
      type={CHECKBOX_TYPE.action}
    />
  )
}

export default HeatingIncludedField
